module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp2_8004.00b230cb.png";